import React from 'react';
import logo from './logo.png';
import './App.css';

function App() {
  return (
    <div className="app">
      <header className="header">
        <img src={logo} className="app-logo" alt="logo" />
        <h1>PSI Console</h1>
      </header>

      <main className="main-content">
        <div className="message-card">
          <div className="icon">&#128205;</div>
          <h2>Site Has Moved</h2>
          <p>This site has moved to the corp network.</p>
          <p>Please update your bookmarks and access it at:</p>
          <a
            className="site-link"
            href="http://spark.fybrlabs.frontier.com"
          >
            spark.fybrlabs.frontier.com
          </a>
        </div>
      </main>

      <footer>
        <p>PSI Console &mdash; Frontier Communications</p>
      </footer>
    </div>
  );
}

export default App;
